import { useMutation, useQueryClient } from '@tanstack/react-query';

import { RECOMMENDATION_SETTING_QUERY_KEY } from './useGetRecommendationSetting';

import RecommendationSettingsService, {
  RecommendationSettingType,
  UpdateRecommendationSettingDto,
} from '@/services/RecommendationSettingsService';

export function useUpdateRecommendationSetting() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({
      type,
      dto,
    }: {
      type: RecommendationSettingType;
      dto: UpdateRecommendationSettingDto;
    }) => RecommendationSettingsService.updateByType(type, dto),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [...RECOMMENDATION_SETTING_QUERY_KEY, variables.type],
      });
    },
  });

  return {
    updateRecommendationSetting: mutateAsync,
    isLoading: isPending,
  };
}
